import { IntakeFlowStep } from "../types/interviewSession";

/** Flow structure — copy lives in i18n (`intake.flow.*`) */
export const INTERVIEW_FLOW: IntakeFlowStep[] = [
  {
    id: "intro",
    type: "intro",
    recordsAudio: true,
  },
  {
    id: "q1",
    type: "question",
    recordsAudio: true,
  },
  {
    id: "q2",
    type: "question",
    skipIndex: 1,
    skipTotal: 3,
    recordsAudio: true,
    skipBranch: ["thinking", "track-choice"],
  },
  {
    id: "thinking",
    type: "thinking",
    autoAdvanceMs: 2200,
    nextStepId: "track-choice",
  },
  {
    id: "track-choice",
    type: "track-choice",
    skipIndex: 2,
    skipTotal: 3,
    options: [
      { id: "personal" },
      { id: "business" },
    ],
  },
  {
    id: "q3",
    type: "question",
    skipIndex: 2,
    skipTotal: 3,
    recordsAudio: true,
  },
  {
    id: "q4",
    type: "question",
    recordsAudio: true,
  },
  {
    id: "accountability-probe",
    type: "question",
    recordsAudio: true,
  },
  {
    id: "deep-q1",
    type: "question",
    recordsAudio: true,
  },
  {
    id: "deep-q2",
    type: "question",
    recordsAudio: true,
  },
];

export const FLOW_STEP_MAP = Object.fromEntries(
  INTERVIEW_FLOW.map((step) => [step.id, step])
) as Record<string, IntakeFlowStep>;

export const MAIN_FLOW_IDS = [
  "intro",
  "q1",
  "q2",
  "q3",
  "q4",
] as const;

export const DEEPER_FLOW_IDS = ["deep-q1", "deep-q2"] as const;

export type InterviewPhase = "main" | "deeper";

export function buildQueueForPhase(phase: InterviewPhase): string[] {
  return phase === "deeper" ? [...DEEPER_FLOW_IDS] : [...MAIN_FLOW_IDS];
}
